export default __webpack_public_path__ + "static/media/44-min.27bc88e6.png";